'use strict';

/**
 * Module dependencies.
 */
var _defineProperty = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var userpilotNodeScript,
  Userpilot = {},
  initializedUserpilot = 0;

/**
 * Initialize.
 *
 * http://help.userpilot.com/
 *
 * @api public
 */

Userpilot.initialize = function (appToken, data) {
  if (appToken) {
    !initializedUserpilot && this.load(appToken, data);
    initializedUserpilot = 1;
  }
};

/**
 * Loaded?
 *
 * @api private
 * @return {boolean}
 */

Userpilot.loaded = function () {
  return typeof window.userpilot !== "undefined";
};

/**
 * Load the Userpilot library.
 *
 * @api private
 * @param {Function} callback
 */

function load(url, sri) {
  userpilotNodeScript = document.createElement('script');
  userpilotNodeScript.setAttribute("src", url);
  if (sri) {
    userpilotNodeScript.setAttribute("integrity", sri);
    userpilotNodeScript.setAttribute("crossorigin", "anonymous");
  }
  document.getElementsByTagName('head')[0].appendChild(userpilotNodeScript);
}
Userpilot.load = function (token, settings) {
  if (typeof window === "undefined") return;
  if (!settings) {
    settings = {};
  }
  var version = settings.version;
  var sri = version ? settings.sri : "";
  settings = _objectSpread(_objectSpread({}, window.userpilotSettings), settings);
  settings.version = settings.version || 'v0';
  settings.endpoint = settings.endpoint || 'api.userpilot.io/socket/';
  settings.token = token;
  window.userpilotSettings = settings;
  var shim = settings.domain ? "https://".concat(settings.domain, "/sdk/latest.js") : "https://js.userpilot.io/sdk/latest.js";
  if (sri) {
    shim = settings.domain ? "https://".concat(settings.domain, "/sdk/version/").concat(version, "/app.js") : "https://js.userpilot.io/sdk/version/".concat(version, "/app.js");
  }
  load(shim, sri);
};

/**
 * reload.
 *
 * https://docs.userpilot.com/article/59-installation-guide-for-single-page-applications-spas
 *
 */

Userpilot.reload = function (url) {
  if (window.userpilot) {
    window.userpilot.reload(url);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.reload(url);
      }
    });
  }
};

/**
 * suppress.
 *
 * Prevents Userpilot from loading content
 *
 */

Userpilot.suppress = function () {
  if (window.userpilot) {
    window.userpilot.suppress();
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.suppress();
      }
    });
  }
};

/**
 * unsuppress.
 *
 * Resumes loading content
 *
 */

Userpilot.unsuppress = function () {
  if (window.userpilot) {
    window.userpilot.unsuppress();
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.unsuppress();
      }
    });
  }
};

/**
 * Identify.
 *
 * https://docs.userpilot.com/article/23-identify-users-track-custom-events
 *
 */

Userpilot.identify = function (userId, identify) {
  if (identify) {
    if (identify.createdAt) {
      identify.created_at = identify.createdAt;
      delete identify.createdAt;
    }
  }
  if (window.userpilot) {
    window.userpilot.identify(userId, identify);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.identify(userId, identify);
      }
    });
  }
};

/**
 * Anonymous.
 *
 * https://docs.userpilot.com/article/48-trigger-an-experience-anonymously
 *
 */

Userpilot.anonymous = function (data) {
  if (window.userpilot) {
    window.userpilot.anonymous(data);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.anonymous(data);
      }
    });
  }
};

/**
 * Trigger.
 *
 * https://docs.userpilot.com/article/50-trigger-an-experience-manually-through-a-script
 *
 */

Userpilot.trigger = function (token) {
  if (window.userpilot) {
    window.userpilot.trigger(token);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.trigger(token);
      }
    });
  }
};

/**
 * On.
 *
 * https://docs.userpilot.com/article/61-javascript-api
 *
 */

Userpilot.on = function (event, callback) {
  if (window.userpilot) {
    window.userpilot.on(event, callback);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.on(event, callback);
      }
    });
  }
};

/**
 * Off.
 *
 * https://docs.userpilot.com/article/61-javascript-api
 *
 */

Userpilot.off = function (event) {
  if (window.userpilot) {
    window.userpilot.off(event);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.off(event);
      }
    });
  }
};

/**
 * Once.
 *
 * https://docs.userpilot.com/article/61-javascript-api
 *
 */

Userpilot.once = function (event, callback) {
  if (window.userpilot) {
    window.userpilot.once(event, callback);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.once(event, callback);
      }
    });
  }
};

/**
 * Track.
 *
 * https://docs.userpilot.com/article/23-identify-users-track-custom-events
 *
 */

Userpilot.track = function (event, meta) {
  if (window.userpilot) {
    window.userpilot.track(event, meta);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.track(event, meta);
      }
    });
  }
};
Userpilot.next = function () {
  if (window.userpilot) {
    window.userpilot.next();
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.next();
      }
    });
  }
};
Userpilot.end = function (type) {
  if (window.userpilot) {
    window.userpilot.end(type);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.end(type);
      }
    });
  }
};
/**
 * Reset.
 *
 * https://docs.userpilot.com/article/67-reset-experiences-seen-for-a-user
 *
 **/
Userpilot.reset = function () {
  if (window.userpilot) {
    window.userpilot.reset();
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.reset();
      }
    });
  }
};
/**
 *
 * Clean.
 *
 * Clear cached data from Userpilot
 *
 **/

Userpilot.clean = function () {
  if (window.userpilot) {
    window.userpilot.clean();
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.clean();
      }
    });
  }
};

/**
 *
 * Destroy.
 *
 * Completely remove Userpilot data/patterns from the page
 *
 **/

Userpilot.destroy = function () {
  if (window.userpilot) {
    window.userpilot.destroy();
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.destroy();
      }
    });
  }
};

/**
 *
 * Theme.
 *
 * Forces Userpilot to use a specific theme
 *
 **/

Userpilot.theme = function (title) {
  if (window.userpilot) {
    window.userpilot.theme(title);
  } else if (typeof userpilotNodeScript !== "undefined") {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilot) {
        window.userpilot.theme(title);
      }
    });
  }
};
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports.Userpilot = Userpilot;
} else {
  window.Userpilot = Userpilot;
}